import React from 'react'
import { ProductWithRelations } from 'Types';
import { getTranslation } from 'dictionary';
import { useUserContext } from 'context/UserContext';
import { useMenuContext } from 'context/MenuContext';
import Link from 'next/link';
import classnames from 'classnames';
import { getFormatedPrice } from 'helpers';
import { getHighAndLowestPrice } from 'helpers/productHelpers';
import getImageUrl from 'helpers/getImageUrl';
import { PlusIcon } from '@heroicons/react/outline';
import createRandomKey from 'helpers/createRandomKey';
import { toast } from 'react-toastify';
import { useCartContext } from 'context/CartContext';


interface Props {
  item: ProductWithRelations;
}

const MenuListWithImage: React.FC <Props> = ({item}) => {
  const { language } = useUserContext();
  const { slug: storeSlug, currency_symbol, features } = useMenuContext();
  const { dispatch } = useCartContext();
  const notify = () =>
    toast.success(getTranslation('menu', 'ADDED_TO_CART', language));

  const price = getHighAndLowestPrice(item);

  return (
    <>
      <Link className="py-4 flex justify-between border-b border-gray-200 active:bg-gray-50" href={`/${storeSlug}/${item.slug}`}>
        <div className='flex flex-col items-start mb-6'>
          <span className={classnames("text-lg", {"opacity-50 cursor-not-allowed" : item.status == 'not_available'})}>{item.title}</span>
          <div className={classnames("flex flex-wrap gap-x-2 items-center",{"opacity-50 cursor-not-allowed" : item.status == 'not_available'})}>
            <span
              className={classnames('font-light text-lg', {
                'line-through text-gray-500':
                  item.price_promotional,
              })}
            >
              {price.uniquePrice ? (
                getFormatedPrice(item.price, currency_symbol)
              ) : (
                <span>
                  {getFormatedPrice(price.lowestPrice || 0, currency_symbol)} -{' '}
                  {getFormatedPrice(price.highestPrice || 0, currency_symbol)}
                </span>
              )}
            </span>
            {item.price_promotional && (
              <span className="font-light text-lg">
                {price.uniquePrice ? (
                  getFormatedPrice(item.price_promotional, currency_symbol)
                ) : (
                  <span>
                    {getFormatedPrice(
                      price.lowestPromotionalPrice || 0,
                      currency_symbol
                    )}{' '}
                    -{' '}
                    {getFormatedPrice(
                      price.highestPromotionalPrice || 0,
                      currency_symbol
                    )}
                  </span>
                )}
              </span>
            )}
          </div>
          {item.status === 'not_available' &&
            <p className="text-base font-light mt-auto lowercase">{getTranslation('menu', 'NOT_AVAILABLE', language)}</p>
          }

        </div>
        {item.images[0] &&
          <img
          src={getImageUrl(item.images[0].url, 80)}
          alt={item.title}
          className={classnames("object-cover h-20 w-20 rounded-lg", {"opacity-50 cursor-not-allowed" : item.status == 'not_available'})}
          height={80}
          width={80}
          />
        }
      </Link>

      {item.status === 'not_available' ||
      item.variants?.length ||
        features === 'CATALOGO' ? null : (
          <button
            aria-label="add to cart"
            className="mt-auto ripple-bg-gray-50 bg-white text-black text-xs font-base p-1 hover:bg-white rounded-full border border-black absolute bottom-4"
            onClick={(e) => {
              e.stopPropagation();
              //@ts-ignore
              dispatch({
                type: 'add_to_cart',
                payload: {
                  itemId: createRandomKey(),
                  product: item,
                  count: 1,
                  extrasSelection: null,
                  variantSelection: {},
                },
              });
              notify();
            }}
          >
            <PlusIcon className="h-3 w-3" />
          </button>
      )}
    </>
  )
}

export default MenuListWithImage